import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/" className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/c82a80d6d696663c2db3260ddbcff61b/2b5a1774ae200f5c812d15f2737b5ea7.png" 
                alt="J's Landscaping" 
                className="h-16 w-auto"
              />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8 xl:space-x-12">
            <Link 
              to="/" 
              className="text-gray-700 hover:text-[#83B328] transition-colors font-medium text-base xl:text-lg border-b-2 border-transparent hover:border-[#83B328] pb-1"
            >
              Home
            </Link>
            <Link 
              to="/services" 
              className="text-gray-700 hover:text-[#83B328] transition-colors font-medium text-base xl:text-lg border-b-2 border-transparent hover:border-[#83B328] pb-1"
            >
              Services
            </Link>
            <Link 
              to="/case-studies" 
              className="text-gray-700 hover:text-[#83B328] transition-colors font-medium text-base xl:text-lg border-b-2 border-transparent hover:border-[#83B328] pb-1"
            >
              Case Studies
            </Link>
          </nav>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 rounded-md text-gray-700 hover:text-[#24820C] cursor-pointer"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-2">
              <Link 
                to="/" 
                className="block px-3 py-3 text-gray-700 hover:text-[#83B328] hover:bg-gray-50 rounded-md transition-colors font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>
              <Link 
                to="/services" 
                className="block px-3 py-3 text-gray-700 hover:text-[#83B328] hover:bg-gray-50 rounded-md transition-colors font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Services
              </Link>
              <Link 
                to="/case-studies" 
                className="block px-3 py-3 text-gray-700 hover:text-[#83B328] hover:bg-gray-50 rounded-md transition-colors font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Case Studies
              </Link>
              <Link 
                to="/qualified-booking" 
                className="block px-3 py-3 text-gray-700 hover:text-[#83B328] hover:bg-gray-50 rounded-md transition-colors font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Book Evaluation
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
